(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hills-shoppable-video"] && !Shopify.designMode) return;
  try {
    
/* ====================================================================================================================
   TT SHOPPABLE VIDEO
   Kopstorm custom section for Hills (Impact theme)

   Defines three custom elements:
     - <tt-quick-add>        : split add-to-cart button with a variant dropdown. Mirrors the theme's ProductForm
                               event contract so the native cart drawer / notification opens and refreshes.
     - <tt-shoppable-video>  : the grid wrapper. Wires card clicks to the reels modal.
     - <tt-reels>            : the fullscreen vertical (TikTok-style) player with up/down navigation, swipe,
                               keyboard, mute and per-slide product card.
   ==================================================================================================================== */

(function () {
  'use strict';

  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var themeVars = window.themeVariables || { settings: {}, strings: {} };

  /* ------------------------------------------------------------------------------------------------------------------
     Shared cart helper. Replicates the sequence used by the theme's <form is="product-form"> so the cart drawer,
     cart notification and cart count all react exactly as they do for a native add to cart.
     ------------------------------------------------------------------------------------------------------------------ */
  async function addVariantToCart(sourceEl, variantId, quantity) {
    var sections = ['variant-added'];

    // Let the cart drawer / notification register the sections they want bundled in the response.
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections: sections } })
    );

    var body = new FormData();
    body.set('id', variantId);
    body.set('quantity', quantity || 1);
    body.set('sections', sections.join(','));
    body.set('sections_url', root + 'variants/' + variantId);

    var response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
      body: body
    });

    var json = await response.json();

    if (!response.ok) {
      sourceEl.dispatchEvent(
        new CustomEvent('cart:error', { bubbles: true, detail: { error: json && json.description } })
      );
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      throw new Error((json && json.description) || 'Add to cart failed');
    }

    // Cart-as-page stores: just go to the cart.
    if (themeVars.settings.cartType === 'page' || themeVars.settings.pageType === 'cart') {
      window.location.href = root + 'cart';
      return json;
    }

    var cart = await (await fetch(root + 'cart.js')).json();
    cart.sections = json.sections;

    var items = Object.prototype.hasOwnProperty.call(json, 'items') ? json.items : [json];

    sourceEl.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: items, cart: cart } }));
    document.documentElement.dispatchEvent(
      new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', cart: cart } })
    );

    return json;
  }

  /* ------------------------------------------------------------------------------------------------------------------
     <tt-quick-add>
     ------------------------------------------------------------------------------------------------------------------ */
  var TtQuickAdd = class extends HTMLElement {
    connectedCallback() {
      this.addButton = this.querySelector('[data-tt-add-default]');
      this.toggle = this.querySelector('[data-tt-toggle]');
      this.menu = this.querySelector('[data-tt-menu]');

      this._onClick = this._onClick.bind(this);
      this._onDocClick = this._onDocClick.bind(this);
      this._onKeydown = this._onKeydown.bind(this);

      this.addEventListener('click', this._onClick);
      this.addEventListener('keydown', this._onKeydown);
    }

    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
    }

    _onClick(event) {
      var addTrigger = event.target.closest('[data-tt-add]');
      if (addTrigger && !addTrigger.disabled) {
        event.preventDefault();
        event.stopPropagation();
        this._add(addTrigger);
        return;
      }

      if (this.toggle && event.target.closest('[data-tt-toggle]')) {
        event.preventDefault();
        event.stopPropagation();
        this.expanded ? this._close() : this._open();
      }
    }

    _onKeydown(event) {
      if (event.key === 'Escape' && this.expanded) {
        event.stopPropagation();
        this._close();
        if (this.toggle) this.toggle.focus();
      }
    }

    _onDocClick(event) {
      if (!this.contains(event.target)) this._close();
    }

    get expanded() {
      return this.getAttribute('aria-expanded') === 'true';
    }

    _open() {
      if (!this.menu) return;
      this.menu.hidden = false;
      this.setAttribute('aria-expanded', 'true');
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'true');
      // Defer so this same click does not immediately close it.
      setTimeout(function () {
        document.addEventListener('click', this._onDocClick);
      }.bind(this), 0);
    }

    _close() {
      if (!this.menu) return;
      this.menu.hidden = true;
      this.setAttribute('aria-expanded', 'false');
      if (this.toggle) this.toggle.setAttribute('aria-expanded', 'false');
      document.removeEventListener('click', this._onDocClick);
    }

    async _add(trigger) {
      var variantId = trigger.getAttribute('data-variant-id');
      if (!variantId) return;

      var label = this.addButton ? this.addButton.querySelector('.tt-qa__add-label') : null;
      var spinner = this.addButton ? this.addButton.querySelector('.tt-qa__spinner') : null;
      var originalText = label ? label.textContent : '';

      this._close();

      if (this.addButton) {
        this.addButton.setAttribute('aria-busy', 'true');
        if (spinner) spinner.hidden = false;
      }

      try {
        await addVariantToCart(this, variantId, 1);
        if (label) {
          var done = themeVars.strings && themeVars.strings.addedToCartWithTitle ? '✓' : '✓';
          label.textContent = done + ' Added';
          var btn = this.addButton;
          setTimeout(function () {
            if (label) label.textContent = originalText;
            if (btn) btn.removeAttribute('aria-busy');
          }, 1400);
        }
      } catch (e) {
        if (label) label.textContent = originalText;
        if (this.addButton) this.addButton.removeAttribute('aria-busy');
      } finally {
        if (spinner) spinner.hidden = true;
        if (this.addButton && this.addButton.getAttribute('aria-busy') === 'true') {
          // keep the brief "Added" state, cleared by the timeout above
        }
      }
    }
  };

  if (!window.customElements.get('tt-quick-add')) {
    window.customElements.define('tt-quick-add', TtQuickAdd);
  }

  /* ------------------------------------------------------------------------------------------------------------------
     <tt-reels> : fullscreen vertical player
     ------------------------------------------------------------------------------------------------------------------ */
  var TtReels = class extends HTMLElement {
    connectedCallback() {
      this.feed = this.querySelector('[data-tt-feed]');
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-tt-slide]'));
      this.prevBtn = this.querySelector('[data-tt-prev]');
      this.nextBtn = this.querySelector('[data-tt-next]');
      this.muteBtn = this.querySelector('[data-tt-mute]');
      this.closeBtn = this.querySelector('[data-tt-close]');
      this.backdrop = this.querySelector('[data-tt-backdrop]');
      this.viewport = this.querySelector('[data-tt-viewport]');

      this.index = 0;
      this.muted = true;
      this._wheelLock = false;
      this._abort = new AbortController();
      var signal = this._abort.signal;

      if (this.prevBtn) this.prevBtn.addEventListener('click', function () { this.go(this.index - 1); }.bind(this), { signal: signal });
      if (this.nextBtn) this.nextBtn.addEventListener('click', function () { this.go(this.index + 1); }.bind(this), { signal: signal });
      if (this.muteBtn) this.muteBtn.addEventListener('click', this._toggleMute.bind(this), { signal: signal });
      if (this.closeBtn) this.closeBtn.addEventListener('click', this.close.bind(this), { signal: signal });
      if (this.backdrop) this.backdrop.addEventListener('click', this.close.bind(this), { signal: signal });

      this.addEventListener('keydown', this._onKeydown.bind(this), { signal: signal });

      if (this.viewport) {
        this.viewport.addEventListener('wheel', this._onWheel.bind(this), { passive: false, signal: signal });
        this.viewport.addEventListener('touchstart', this._onTouchStart.bind(this), { passive: true, signal: signal });
        this.viewport.addEventListener('touchend', this._onTouchEnd.bind(this), { passive: true, signal: signal });
        this.viewport.addEventListener('click', this._onTapToggle.bind(this), { signal: signal });
      }
    }

    disconnectedCallback() {
      this._abort.abort();
    }

    open(index) {
      this.index = Math.max(0, Math.min(index || 0, this.slides.length - 1));
      this.setAttribute('open', '');
      this.setAttribute('data-paused', 'false');
      this._render(false);
      // Floating PiP: do not lock body scroll and do not steal focus, so the page stays scrollable.
      this.dispatchEvent(new CustomEvent('tt-reels:open', { bubbles: true }));
    }

    close() {
      this.removeAttribute('open');
      this.slides.forEach(this._pauseSlide, this);
      this.dispatchEvent(new CustomEvent('tt-reels:close', { bubbles: true }));
    }

    get isOpen() {
      return this.hasAttribute('open');
    }

    go(index) {
      if (index < 0 || index > this.slides.length - 1) return;
      this.index = index;
      this._render(true);
    }

    _render(animate) {
      var i = this.index;
      if (this.feed) {
        if (!animate) {
          var prevTransition = this.feed.style.transition;
          this.feed.style.transition = 'none';
          this.feed.style.transform = 'translateY(' + (-i * 100) + '%)';
          // Force reflow then restore transition.
          void this.feed.offsetHeight;
          this.feed.style.transition = prevTransition || '';
        } else {
          this.feed.style.transform = 'translateY(' + (-i * 100) + '%)';
        }
      }

      this.slides.forEach(function (slide, idx) {
        var active = idx === i;
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        if (active) {
          this._activateSlide(slide);
        } else {
          this._pauseSlide(slide);
        }
      }, this);

      if (this.prevBtn) this.prevBtn.disabled = i <= 0;
      if (this.nextBtn) this.nextBtn.disabled = i >= this.slides.length - 1;

      // Still-image slides have no <video> and no embed: flag them so CSS can hide the
      // mute button and tap-to-pause glyph, and never leave the paused affordance showing.
      var activeSlide = this.slides[i];
      var isImage = activeSlide && !activeSlide.querySelector('video') && !activeSlide.querySelector('[data-tt-embed]');
      this.setAttribute('data-active-image', isImage ? 'true' : 'false');
      if (isImage) this.setAttribute('data-paused', 'false');
    }

    _activateSlide(slide) {
      // Native video
      var video = slide.querySelector('video');
      if (video) {
        this.setAttribute('data-paused', 'false');
        video.muted = this.muted;
        video.loop = true;
        video.playsInline = true;
        var p = video.play();
        if (p && typeof p.catch === 'function') {
          p.catch(function () {
            // Autoplay with sound can be blocked; fall back to muted.
            video.muted = true;
            video.play().catch(function () {});
          });
        }
        return;
      }

      // Embed (YouTube / Vimeo / Instagram) lazy-injected from a template the first time the slide is shown.
      var holder = slide.querySelector('[data-tt-embed]');
      if (holder && !holder.dataset.loaded) {
        var tpl = holder.querySelector('template');
        if (tpl) {
          holder.appendChild(tpl.content.cloneNode(true));
          holder.dataset.loaded = 'true';
          if (holder.dataset.embed === 'instagram') this._loadInstagram();
        }
      }
    }

    _pauseSlide(slide) {
      var video = slide.querySelector('video');
      if (video && !video.paused) video.pause();
    }

    _onTapToggle(event) {
      // Ignore taps on the controls, product card, links or embeds; only toggle on the video surface.
      if (
        event.target.closest('.tt-reels__btn') ||
        event.target.closest('.tt-reels__product') ||
        event.target.closest('tt-quick-add') ||
        event.target.closest('a') ||
        event.target.closest('[data-tt-embed]')
      ) {
        return;
      }
      var active = this.slides[this.index];
      var video = active ? active.querySelector('video') : null;
      if (!video) return;
      if (video.paused) {
        video.play().catch(function () {});
        this.setAttribute('data-paused', 'false');
      } else {
        video.pause();
        this.setAttribute('data-paused', 'true');
      }
    }

    _toggleMute() {
      this.muted = !this.muted;
      this.setAttribute('data-muted', this.muted ? 'true' : 'false');
      var active = this.slides[this.index];
      var video = active ? active.querySelector('video') : null;
      if (video) video.muted = this.muted;
      this._renderMuteIcon();
    }

    _renderMuteIcon() {
      if (!this.muteBtn) return;
      var on = this.muteBtn.querySelector('[data-icon-unmuted]');
      var off = this.muteBtn.querySelector('[data-icon-muted]');
      if (on) on.hidden = this.muted;
      if (off) off.hidden = !this.muted;
      this.muteBtn.setAttribute('aria-label', this.muted ? 'Unmute' : 'Mute');
    }

    _loadInstagram() {
      if (window.instgrm && window.instgrm.Embeds) {
        window.instgrm.Embeds.process();
        return;
      }
      if (document.getElementById('tt-instagram-embed-sdk')) return;
      var s = document.createElement('script');
      s.id = 'tt-instagram-embed-sdk';
      s.async = true;
      s.src = 'https://www.instagram.com/embed.js';
      document.body.appendChild(s);
    }

    _onKeydown(event) {
      if (!this.isOpen) return;
      switch (event.key) {
        case 'Escape':
          event.preventDefault();
          this.close();
          break;
        case 'ArrowDown':
        case 'ArrowRight':
          event.preventDefault();
          this.go(this.index + 1);
          break;
        case 'ArrowUp':
        case 'ArrowLeft':
          event.preventDefault();
          this.go(this.index - 1);
          break;
        case 'm':
        case 'M':
          this._toggleMute();
          break;
      }
    }

    _onWheel(event) {
      // Ignore wheel that originates inside the scrollable variant menu.
      if (event.target.closest('.tt-qa__menu')) return;
      event.preventDefault();
      if (this._wheelLock) return;
      if (Math.abs(event.deltaY) < 12) return;
      this._wheelLock = true;
      this.go(this.index + (event.deltaY > 0 ? 1 : -1));
      setTimeout(function () { this._wheelLock = false; }.bind(this), 520);
    }

    _onTouchStart(event) {
      this._touchY = event.changedTouches[0].clientY;
      this._touchX = event.changedTouches[0].clientX;
    }

    _onTouchEnd(event) {
      if (event.target.closest('.tt-reels__product') || event.target.closest('.tt-qa__menu')) return;
      var dy = event.changedTouches[0].clientY - (this._touchY || 0);
      var dx = event.changedTouches[0].clientX - (this._touchX || 0);
      if (Math.abs(dy) < 45 || Math.abs(dy) < Math.abs(dx)) return;
      this.go(this.index + (dy < 0 ? 1 : -1));
    }
  };

  if (!window.customElements.get('tt-reels')) {
    window.customElements.define('tt-reels', TtReels);
  }

  /* ------------------------------------------------------------------------------------------------------------------
     <tt-shoppable-video> : grid wrapper, opens the reels modal on card click.
     ------------------------------------------------------------------------------------------------------------------ */
  var TtShoppableVideo = class extends HTMLElement {
    connectedCallback() {
      this._onClick = this._onClick.bind(this);
      this.addEventListener('click', this._onClick);

      var reelsId = this.getAttribute('data-reels');
      this.reels = reelsId ? document.getElementById(reelsId) : null;

      this._pausedByModal = [];
      if (this.reels) {
        this.reels.addEventListener('tt-reels:open', this._pauseGridVideos.bind(this));
        this.reels.addEventListener('tt-reels:close', this._resumeGridVideos.bind(this));
      }

      // Mobile / tablet / desktop-slider carousel: arrows + progress bar driven by the scroll position.
      this.track = this.querySelector('[data-tt-track]');
      this.prevCard = this.querySelector('[data-tt-prev-card]');
      this.nextCard = this.querySelector('[data-tt-next-card]');
      this.progressFill = this.querySelector('[data-tt-progress-fill]');
      this._updateProgress = this._updateProgress.bind(this);

      if (this.prevCard) this.prevCard.addEventListener('click', this._scrollByPage.bind(this, -1));
      if (this.nextCard) this.nextCard.addEventListener('click', this._scrollByPage.bind(this, 1));

      if (this.track) {
        this.track.addEventListener('scroll', this._updateProgress, { passive: true });
        requestAnimationFrame(this._updateProgress);
        if (window.ResizeObserver) {
          this._ro = new ResizeObserver(this._updateProgress);
          this._ro.observe(this.track);
        } else {
          window.addEventListener('resize', this._updateProgress);
        }
      }
    }

    disconnectedCallback() {
      this.removeEventListener('click', this._onClick);
      if (this._ro) this._ro.disconnect();
    }

    _scrollByPage(dir) {
      if (!this.track) return;
      this.track.scrollBy({ left: dir * this.track.clientWidth, behavior: 'smooth' });
    }

    _updateProgress() {
      if (!this.track) return;
      var max = this.track.scrollWidth - this.track.clientWidth;
      if (max <= 1) {
        // No overflow (e.g. grid mode): fill the bar and disable the arrows.
        if (this.progressFill) {
          this.progressFill.style.insetInlineStart = '0%';
          this.progressFill.style.width = '100%';
        }
        if (this.prevCard) this.prevCard.disabled = true;
        if (this.nextCard) this.nextCard.disabled = true;
        return;
      }
      var left = this.track.scrollLeft;
      if (this.progressFill) {
        this.progressFill.style.width = (this.track.clientWidth / this.track.scrollWidth) * 100 + '%';
        this.progressFill.style.insetInlineStart = (left / this.track.scrollWidth) * 100 + '%';
      }
      if (this.prevCard) this.prevCard.disabled = left <= 1;
      if (this.nextCard) this.nextCard.disabled = left >= max - 1;
    }

    _pauseGridVideos() {
      this._pausedByModal = [];
      var videos = this.querySelectorAll('.tt-shop__media video');
      for (var i = 0; i < videos.length; i++) {
        if (!videos[i].paused) {
          videos[i].pause();
          this._pausedByModal.push(videos[i]);
        }
      }
    }

    _resumeGridVideos() {
      for (var i = 0; i < this._pausedByModal.length; i++) {
        var v = this._pausedByModal[i];
        if (v && v.isConnected) v.play().catch(function () {});
      }
      this._pausedByModal = [];
    }

    _onClick(event) {
      var opener = event.target.closest('[data-tt-open]');
      if (!opener) return;
      // Do not hijack clicks on the add-to-cart controls or product links.
      if (event.target.closest('tt-quick-add') || event.target.closest('a')) return;
      event.preventDefault();
      var index = parseInt(opener.getAttribute('data-tt-open'), 10) || 0;
      if (this.reels) this.reels.open(index);
    }
  };

  if (!window.customElements.get('tt-shoppable-video')) {
    window.customElements.define('tt-shoppable-video', TtShoppableVideo);
  }
})();


  } catch(e) { console.error(e); }
})();
})();
